import classNames from 'classnames';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { BodyText, Button, Headline } from '@servicetitan/design-system';

import { environment, SiteMode } from '../../api';
import { isLocalPath, Paths } from '../../paths';
import * as Styles from '../assets/public-home-page.module.scss';

export const PublicHomePage: FC = () => {
    const history = useHistory();
    const isPartnerApisMode = environment.site.mode === SiteMode.PartnerApis;

    return (
        <div className={Styles.publicHomePage}>
            <div
                className={classNames(
                    Styles.welcome,
                    isPartnerApisMode ? Styles.partnerApis : Styles.tenantApis,
                )}
            >
                <h1 className="Headline">
                    {isPartnerApisMode
                        ? 'ServiceTitan Partner APIs'
                        : 'Welcome to ServiceTitan\u00A0APIs'}
                </h1>
                <Button
                    primary
                    onClick={() => {
                        history.push('/signin');
                    }}
                >
                    Sign In & Register Apps
                </Button>
            </div>
            <div className={Styles.requestAccess}>
                <Headline size="large">
                    {isPartnerApisMode
                        ? 'Build seamless integrations to Supply Chain, Marketing Pro, and more'
                        : 'Build integrations securely and seamlessly'}
                </Headline>
                <BodyText className="m-t-2 m-b-4">
                    ServiceTitan’s {isPartnerApisMode ? 'partner' : 'V2'} APIs provide enhanced
                    security, performance, and self-service access to developer tools and resources.
                    Build powerful integrations that solve business challenges and help your
                    business grow—request {!isPartnerApisMode && 'integration environment '}access
                    to get started!
                </BodyText>
                <Button
                    primary
                    outline
                    onClick={() => {
                        if (isLocalPath(Paths.requestAccess)) {
                            history.push(Paths.requestAccess);
                        } else {
                            window.open(Paths.requestAccess, '_blank', 'noopener,noreferrer');
                        }
                    }}
                >
                    Request Access
                </Button>
            </div>
        </div>
    );
};
PublicHomePage.displayName = 'PublicHomePage';
